import React, { useState } from 'react'
import axios from 'axios'
import { toast } from 'sonner'
import { useUser } from '../../../store/userState'
import CouponsTable from './CouponsTable'
import { TicketIcon } from '@heroicons/react/24/solid'
import generateTimestamp from '../../../middlewares/GlobalUtils/generateTimeStamp'
import AppShell from '../../../Components/AppShell'
import PageHeader from '../../../Components/PageHeader'

const CouponPromotions = () => {
  const { user } = useUser()
  const userEmail = user.email
  const [isAltered, setIsAltered] = useState(false)
  const [coupon, setCoupon] = useState('')

  const handleSetCoupon = (event) => {
    setCoupon(event.target.value)
  }

  const handleRequestCoupons = () => {
    if (!coupon) {
      toast.error('Coupon ID is required.')
      return
    }

    const batchImportData = {
      batchId: generateTimestamp(),
      couponId: coupon,
      addedBy: userEmail,
    }

    axios
      .post('/api/coupon-promotions/add', batchImportData)
      .then((response) => {
        if (response.data.message) {
          toast.success(`${response.data.message}`)
          setIsAltered((prevstate) => !prevstate)
          setCoupon('')
        } else {
          toast.error(`${response.data.message}`)
        }
      })
      .catch((error) => {
        console.error('Error:', error)
        const errorMessage = error.response?.data?.message || 'An error occurred during add.'
        toast.error(errorMessage)
      })
  }

  return (
    <AppShell>
      <PageHeader
        kicker="Pricing"
        title="Coupon promotions"
        subtitle="Submit coupon IDs and export promotion batches."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Pricing', to: '/pricing-tools' },
          { label: 'Coupons' },
        ]}
      />

      <div className="nx-panel mb-4 flex flex-col gap-3 p-4 sm:flex-row sm:items-end">
        <div className="flex-1">
          <label htmlFor="coupon-id" className="nx-label">
            Enter new coupon
          </label>
          <div className="relative">
            <input
              id="coupon-id"
              className="nx-input pr-10"
              type="text"
              value={coupon}
              placeholder="f9222564-b3e2-4fc6-8e3b-114a96cd0c95"
              onChange={handleSetCoupon}
            />
            <TicketIcon className="pointer-events-none absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-signal" />
          </div>
        </div>
        <button type="button" className="nx-btn-primary" onClick={handleRequestCoupons}>
          Submit
        </button>
      </div>

      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <CouponsTable isAltered={isAltered} />
      </div>
    </AppShell>
  )
}

export default CouponPromotions
